// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ch3lb","content":"styles_content__1AxJ3"};